export default __webpack_public_path__ + "static/media/14.ae72ea0f.jpg";